import { render, staticRenderFns } from "./agriculture.vue?vue&type=template&id=3cdedda1"
import script from "./agriculture.vue?vue&type=script&lang=js"
export * from "./agriculture.vue?vue&type=script&lang=js"
import style0 from "./agriculture.vue?vue&type=style&index=0&id=3cdedda1&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports